import { get } from 'lodash';

export default resp =>
  resp
    .filter(subReq => subReq.code >= 400)
    .map(item => get(item, 'payload.errors[0]'));
